class StoreSelectController {
  /* @ngInject */
  constructor($rootScope, $scope, StoreService, ModalFactory, $timeout, MerchantDetailStore) {
    const that = this;
    that.lista = [];
    that.selectedStore = undefined;
    that.loading = false;
    
    that.initStoreList = () => {
      that.loading = true;
      that.selectedStore = StoreService.getSelectedStore();
      that.lista = _.map(StoreService.getSavedStoreList(), store => 
        { return {
            option: store.name+", "+store.address,
            id: store.id
          }
        });
        if(that.selectedStore == undefined){
          that.selectedStore = that.lista[0];
          StoreService.setSelectedStore(that.selectedStore);
        }else if(that.selectedStore != undefined && that.selectedStore.id == that.lista[0]){
          that.selectedStore = that.lista[0];
          StoreService.setSelectedStore(that.selectedStore);
        } else {
          var index = that.lista.findIndex(store => store.id == StoreService.getSelectedStore().id); 
          that.selectedStore= that.lista[index];
        }
        $rootScope.$broadcast('$storeChangeSuccess')  
        that.loading = false;
    } 

    that.initStoreList();

    that.updateChange = (store) => {
      StoreService.setSelectedStore(store);
      MerchantDetailStore.forceExpired();
      $rootScope.$broadcast('$storeChangeSuccess')  
      if(that.callback) that.callback(); 
    }

    $rootScope.storeSelected = (store) => {
      console.log("FROM TOP SELECT", store)
      that.selectedStore = that.lista.find(el => {return el.id == store.id})
      that.updateChange(store)
    }

    that.searchStore = () => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: '<search-store mode="create" on-cancel="cancel()"></search-store>',
        class: 'large',
        contentScope: {
          cancel: () => closeModal(modal), 
        }
      });

      modal.activate();
    };

    const closeModal = modal => {
      modal.deactivate();
      $timeout(modal.destroy, 1000);
    };

    const deStoreListRefresh = $scope.$on(`STORE_LIST_UPDATE`, () => {
      that.initStoreList();
    });

  }
}

export default StoreSelectController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/storeSelect/storeSelect.controller.js
 **/